// client/src/data/nieuwsbrief.js

/**
 * News posts for the Nieuwsbrief page
 * 
 * HOW TO ADD A NEW POST:
 * 1. Copy one of the example objects below
 * 2. Update the id (must be unique)
 * 3. Update all fields with your content
 * 4. Save the file - the post will automatically appear on the Nieuwsbrief page
 * 
 * FIELDS EXPLAINED:
 * - id: Unique number for each post
 * - title: Post title (shown in list and detail)
 * - date: Publication date in format "YYYY-MM-DD"
 * - author: Who wrote the post (optional)
 * - slug: URL-friendly version of title (use lowercase, hyphens, no spaces)
 * - excerpt: Short summary (2-3 sentences) shown on list page
 * - content: Full post content (use \n\n for paragraphs, **text** for bold, - for bullets)
 * - imageUrl: Path to featured image (optional, e.g., "/images/news/post1.jpg")
 * - category: Post category like "Nieuws", "Tips", "Updates" (optional)
 * - published: Set to false to hide a post (optional, defaults to true)
 */

export const newsPosts = [
  

    {
  id: 4,
  title: "Stand van zaken: onze eerste e-learning komt eraan",
  date: "2025-12-09",
  author: "LerenMotiveren Team",
  slug: "stand-van-zaken-eerste-e-learning",
  excerpt: "We werken aan de laatste inhoudelijke details en verwachten begin volgend jaar onze eerste scholing 'Haal meer uit verandertaal' geaccrediteerd en online beschikbaar te hebben.",
  content: `De afgelopen maanden hebben we hard gewerkt aan onze eerste e-learning binnen LerenMotiveren. We zitten nu in de afrondende fase waarin we de puntjes op de 'i' zetten.

We verwachten begin volgend jaar de scholing **Haal meer uit verandertaal** geaccrediteerd en online beschikbaar te hebben voor paramedici.

**Waarom deze scholing?**

Het viel ons op dat er in de zorgwereld grofweg twee soorten trainingen bestaan:

1. Passieve e-learnings 
Eenvoudig te volgen, maar vooral gericht op kennis. Veel tekst, video’s en toetsvragen, maar weinig gelegenheid om echt te oefenen.

2. Klassikale trainingen met acteurs 
Enorm waardevol en onvervangbaar. Maar ook prijzig, intensief en lastig in te plannen binnen de drukke werkschema's van paramedici en andere zorgverleners.

We vroegen ons af of het mogelijk was om het beste van deze twee werelden te combineren. **Kunnen we AI inzetten** om een scholing te ontwikkelen die wél laagdrempelig en flexibel is, maar ook gericht op echt oefenen?

Daaruit ontstond het idee voor LerenMotiveren: interactieve e-learnings waarin je gesprekstechnieken oefent in realistische simulaties en direct persoonlijke feedback ontvangt.

We kijken ernaar uit om binnenkort de eerste e-learning **Haal meer uit verandertaal** met jullie te delen.`,
  imageUrl: null,
  category: "Nieuws",
  published: true
}

    
    // ADD MORE POSTS HERE:
    // Copy the structure above and update with your own content
    
  ];
  
  /**
   * Helper function to get all published posts sorted by date (newest first)
   * This is automatically used by the NieuwsbriefPage component
   */
  export const getPublishedPosts = () => {
    return newsPosts
      .filter(post => post.published !== false)
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };
  
  /**
   * Helper function to get a single post by its slug
   * This is used by the PostDetailPage component
   */
  export const getPostBySlug = (slug) => {
    return newsPosts.find(post => post.slug === slug && post.published !== false);
  };
  
  /**
   * Helper function to get posts by category
   */
  export const getPostsByCategory = (category) => {
    return newsPosts
      .filter(post => post.category === category && post.published !== false)
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };